import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-MultiListChooser',
	filter: 'c-MultiListChooser__filter',
	chooserContainer: 'c-MultiListChooser__container',
	title: 'c-MultiListChooser__title',
	group: {
		container: 'c-MultiListChooser__group',
		title: 'c-MultiListChooser__groupTitle',
		selectionWrap: 'c-MultiListChooser__groupSelectWrap',
		selection: 'c-MultiListChooser__groupSelect',
	},
	modal: 'c-MultiListChooser__modal',
	colorIndicator: 'c-MultiListChooser__colorIndicator',
};

export const Style = {
	[CSS.title]: {
		'font-weight': DefaultTheme.font.weight.bold,
	},
	[CSS.container]: {
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		'flex-direction': 'column',
	},
	[CSS.chooserContainer]: {
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		width: '100%',
	},
	[CSS.group.container]: {
		width: '100%',
		height: '240px',
		display: 'flex',
		'flex-direction': 'column',
	},
	[CSS.group.title]: {
		'font-family': DefaultTheme.font.familyCondensed,
		'font-weight': DefaultTheme.font.weight.bold,
		'padding-bottom': DefaultTheme.space(4),
	},
	[CSS.group.selectionWrap]: {
		'background-color': DefaultTheme.background.grey,
		flex: 1,
		overflow: 'auto',
	},
	[`${CSS.group.container}:nth-child(even) .${CSS.group.selectionWrap}`]: {
		'background-color': DefaultTheme.background.lightGrey,
	},
	[CSS.group.selection]: {
		position: 'relative',
		display: 'flex',
		'&:hover': {
			'background-color': DefaultTheme.font.color.divider,
		},
		'& input': {
			appearance: 'none',
			'&::-ms-check': {
				display: 'none',
			},
			position: 'absolute',
		},
		'& input + label': {
			width: '100%',
			'border-left': `${DefaultTheme.space(1)} solid transparent`,
			'padding-left': DefaultTheme.space(1),
		},
		'& input:focus + label': {
			outline: `1px solid ${DefaultTheme.color.accent}`,
			'margin-right': '1px',
		},
		'& input:checked + label': {
			'background-color': DefaultTheme.background.offWhite,
			'border-left': `${DefaultTheme.space(1)} solid ${DefaultTheme.color.accent}`,
			'padding-left': DefaultTheme.space(1),
			'box-shadow': DefaultTheme.shadow.box.dp2,
		},
	},
	[CSS.modal]: {
		'min-width': '800px',
	},
	[CSS.filter]: {
		display: 'flex',
		width: '100%',
		'padding-bottom': DefaultTheme.space(4),
		'& input:hover': {
			'background-color': DefaultTheme.font.color.divider,
		},
		'& input': {
			width: '100%',
			border: `${DefaultTheme.space(1)} solid transparent`,
			'padding-left': DefaultTheme.space(1),
		},
		'& input:focus': {
			outline: `1px solid ${DefaultTheme.color.accent}`,
			'margin-right': '1px',
		},
		'& input:checked': {
			'background-color': DefaultTheme.background.offWhite,
			'border-left': `${DefaultTheme.space(1)} solid ${DefaultTheme.color.accent}`,
			'padding-left': DefaultTheme.space(1),
			'box-shadow': DefaultTheme.shadow.box.dp2,
		},
	},
	[CSS.colorIndicator]: {
		width: '12px',
		height: '12px',
		position: 'absolute',
		top: '50%',
		right: '4px',
		transform: 'translateY(-50%)',
		borderRadius: '50%',
	},
};
